module.exports = __webpack_public_path__ + "img/u662.40784465.jpg";